<script setup lang="ts">
import {} from 'lucide-vue-next';

const route = useRoute();
const shouldHideTopBar = computed(() => route.meta?.hideTopBar === true);
</script>

<template>
  <div class="min-h-screen">
    <TopBar v-if="!shouldHideTopBar" :sidebar-open="false" />
    <main :class="shouldHideTopBar ? 'align-baseline' : 'pt-16 mt-4 align-baseline'">
      <slot />
      <VideoModal />
    </main>
  </div>
</template>
